var _style, _line, _line2, _line3, _ellipse, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _polyline, _line1, _path, _line10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowIntensityLamps({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Low Intensity Lamps") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.9,
    y1: 3.1,
    x2: 2.3,
    y2: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.3,
    y1: 7.3,
    x2: 0,
    y2: 7.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.8,
    y1: 12.8,
    x2: 2.3,
    y2: 14.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 8,
    cy: 7.8,
    rx: 5,
    ry: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.4,
    y1: 12.6,
    x2: 13.6,
    y2: 14.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.1,
    y1: 14,
    x2: 8.1,
    y2: 16.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.7,
    y1: 7.3,
    x2: 16,
    y2: 7.3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.2,
    y1: 3.6,
    x2: 13.8,
    y2: 1.9
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.3,
    y1: 9.6,
    x2: 9.7,
    y2: 3.1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.4,
    y1: 11.3,
    x2: 11.2,
    y2: 4
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6,
    y1: 12.4,
    x2: 12.4,
    y2: 5.3
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "9.1,3 7.6,2.9 7.4,2.8 6.9,2.9 6.9,2.6 6.9,0.6 9.1,0.6 9.1,2.8 9.1,3 "
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.7,
    y1: 12.8,
    x2: 13,
    y2: 7.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.3,2.8"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 3,
    y1: 7.8,
    x2: 7.8,
    y2: 2.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowIntensityLamps);
export default __webpack_public_path__ + "static/media/LowIntensityLamps.65d1b56c2322517f5a8d56dcff7b88b0.svg";
export { ForwardRef as ReactComponent };